import Decimal from 'decimal.js'
import type { z } from 'zod'
import type { billSchema } from '@super-mega/server/contracts/bill'

// 草稿尚未出账，余额为 0 不代表已结清，不能按已结清批量移除。
export function isBillWithoutReceivableBalance(bill: z.infer<typeof billSchema>) {
  return bill.status === 'issued' && new Decimal(bill.outstandingAmount).lte(0)
}
